import Loader from "components/AppUI/Loaders/Loader";
import Card from "components/Card/Card";
import CardAddingInputs from "components/CardAddingInputs/CardAddingIntuts";
import "../../assets/styles/styleAppMain.scss";
import "../Card/CardStyle.scss";
import "./CardList.scss";
import { observer, inject } from "mobx-react";

const CardsList = inject(["store"])(
  observer(({ store }) => {
    const getContent = () => (
      <>
        {store.loading && <Loader />}
        {store.error && (
          <h1>
            If you have problems on the server, please contact the support
            service
          </h1>
        )}
        {!store.loading && !store.error && (
          <>
            {store.listOfWords.map((element) => {
              return (
                <Card
                  key={element.id}
                  id={element.id}
                  name={element.english}
                  transcription={element.transcription}
                  translation={element.russian}
                  topic={element.tags}
                  new={element.new}
                  main={element.main}
                />
              );
            })}
          </>
        )}
      </>
    );

    return (
      <main className="cardsList-container">
        <CardAddingInputs />
        {getContent()}
      </main>
    );
  })
);
export default CardsList;
